<template>
<div main class="ion-page">
  <ion-content color="light">
    <ion-grid>
      <ion-row>
        <ion-col></ion-col>
        <ion-col size-xl="3" size-lg="3" size-md="4" size-sm="6" size-xs="12">
          <ion-row>
            <ion-col></ion-col>
            <ion-col size-xs="8" size-sm="10" size-md="12" onclick="window.location.reload()">
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <img src="@/../public/brand/logo.png" v-if="esTecnhos" />
              <img src="@/../public/logo.png" v-else />
            </ion-col>
            <ion-col></ion-col>
          </ion-row>
          <p>&nbsp;</p>
          <ion-card>
            <ion-list>
              <ion-item color="secondary">
                <ion-note slot="start">
                  <i class="icon ion-ios-person"></i>
                </ion-note>
                <ion-input debounce="50" :value="usuario" placeholder="Usuario o email" type="email" v-on:ionChange="set('usuario',$event.detail.value)" v-on:keyup.enter="login()" clear-input="true"></ion-input>
              </ion-item>
              <ion-item v-if="usuario!=''" color="secondary">
                <ion-note slot="start" lines="none">
                  <i class="icon ion-ios-lock"></i>
                </ion-note>
                <ion-input debounce="50" :value="password" placeholder="Contraseña" type="password" v-on:ionChange="set('password',$event.detail.value)" v-on:keyup.enter="login()" clear-input="true"></ion-input>
              </ion-item>
              <!--ion-item lines="none" v-if="usuario!='' && !esBdLocal">
                <ion-note slot="start" color="primary">
                  <i class="icon ion-ios-briefcase"></i>
                </ion-note>
                <ion-input color="primary" debounce="50" :value="empresa" placeholder="Empresa" type="text" v-on:ionChange="set('empresa',$event.detail.value)" v-on:keyup.enter="login()" clear-input="true"></ion-input>
              </ion-item-->
              <ion-item v-if="usuario!=''" :color="botonLogin=='Entrar'?'primary':'warning'">
                <ion-note slot="start" color="light" lines="none">
                  <i class="icon ion-ios-log-in"></i>
                </ion-note>
                <ion-label @click="login">
                  <h2>{{botonLogin}}</h2>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
        <ion-col></ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</div>
</template>
<script>
import Api from '@/components/Api/Api'
import Bitacora from '@/models/Bitacora'
export default {
  name: 'Login',
  //components: {GoogleFirebaseButton},
  data() {
    return {
      loginTemplate: 'default',
      esTecnhos: window.location.href.indexOf('tecnhos') >= 0,
      googleHabilitado: false,
      usuario: '',
      email: '',
      password: '',
      empresa: '',
      servidor: Api.servidor,
      servidorDefault: Api.servidor,
      pin: '',
      botonLogin: 'Entrar',
      esBdLocal: false,
      mostrarAvanzado: false
    }
  },
  methods: {
    set(campo, valor) {
      valor = valor || ''
      this[campo] = valor
      if (campo == 'empresa' && valor && valor != '' && typeof valor != 'object')
        try {
          let empresa = (valor || '').trim().toLowerCase()
          if (!(valor.startsWith('http:') || valor.startsWith('https:'))) {
            this.servidor = Api.servidorDefault.replace('test', valor)
            console.log("Detectada base de datos para acoplar desde Atlatl", valor)
          } else {
            this.servidor = valor
            console.log("Detectada URL de servidor", valor.split('/'))
            valor = valor.split('/')[valor.split('/').length - 1]
            console.log("Detectada la empresa", valor, this.servidor)
          }
          Api.saveLocal('hb3.empresastr', valor)
          Api.saveLocal('hb3.servidor', this.servidor)
          localStorage.setItem('hb3.modoOffline', 0)
          console.info("Configurando servidor", valor, this.servidor)
          Api.cambiarServidor(this.servidor)
          this.$forceUpdate()
        } catch (e) {
          console.error(e)
        }
      console.log("Set", campo, valor)
    },
    async login() {
      this.botonLogin = 'Iniciando...'
      let filtros = []
      if (this.pin.length >= 4)
        //filtros = ['pin,eq,' + this.pin]
        filtros = []
      else
      if (this.usuario.length > 0 && this.password.length > 0)
        filtros = [
          'email,eq,' + this.usuario,
          'password,eq,' + this.password
        ]
      else this.botonLogin = 'Faltan datos'
      try {
        let coincidencias = await Api.login(this.usuario, this.password)
        console.log("LOGIN Buscando", filtros, coincidencias)
        if (coincidencias && (coincidencias.length == 1 || coincidencias._id)) {
          let usuario = (coincidencias._id) ? coincidencias : coincidencias[0]
          this.botonLogin = 'Usuario encontrado'
          console.log("Recargando App")
          Api.saveLocal('hb3.lastUser', usuario.email)
          // Catalogos offline
          if (typeof CatalogosOffline != 'undefined' && usuario.permitirForzarModoOffline) {
            const loadingController = document.querySelector('ion-loading-controller')
            await loadingController.componentOnReady()
            const loadingElement = await loadingController.create({
              message: 'Descargando catalogos',
              spinner: 'crescent'
            })
            await loadingElement.present()
            try {
              await CatalogosOffline.inicializarTodos()
            } catch (e) {
              alert("No se pudieron inicializar todos los catálogos")
            }
            await loadingElement.dismiss()
          }
          //
          setTimeout(_ => {
            Bitacora.guardar('Usuario inicia sesión: ' + usuario.email)
            let empresa = Api.fetchLocal('hb3.empresadb') || {}
            console.log("Necesito mostrar el wizard?", empresa)
            this.$router.push('/')
            window.location.reload()
          }, 500)
        } else if (coincidencias.length > 1) {
          coincidencias = coincidencias.filter(c => {
            return c.pin && c.pin.toString() == this.pin.toString()
          })
          if (coincidencias && coincidencias[0]) {
            console.log("Encontrada por pin", coincidencias[0])
            Api.$emit('logged-in', coincidencias[0])
            this.$router.push('/hola')
          }
          window.location.reload()
        } else {
          this.password = ''
          this.botonLogin = 'Credenciales incorrectas'
        }
      } catch (e) {
        console.error("EEE", e)
        this.botonLogin = 'Credenciales incorrectas'
      }
      let vm = this
      setTimeout(function() {
        vm.botonLogin = 'Entrar'
        vm.$forceUpdate()
      }, 1500)
    },
    botonConfigurar() {
      this.mostrarAvanzado = !this.mostrarAvanzado
      this.$forceUpdate()
    },
    toggleBdLocal(val) {
      localStorage.setItem('hb3.engine', (val == true) ? 'localStorage' : 'wst')
      window.location.reload()
    }
  },
  mounted() {
    let engine = Api.fetchLocal('hb3.engine') || 'wst'
    if (engine == 'localStorage')
      this.esBdLocal = true
    //
    let usuarioAnterior = Api.fetchLocal('hb3.lastUser')
    if (usuarioAnterior && !this.esBdLocal) {
      this.set('usuario', usuarioAnterior)
    }
    let yo = Api.fetchLocal('cmms.yo') || {}
    if (yo && yo._id) {
      this.$router.push('/')
      toast("Hola de nuevo, " + yo.nombre)
    }
    //
    this.$forceUpdate()
  }
}
</script>
